import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { SandboxDetailPage } from './pages/SandboxDetailPage';
import { SandboxV2DetailPage } from './pages/SandboxV2DetailPage';
import { SandboxListPage } from './pages/SandboxListPage';
import { validateSandboxesListSearch } from './sandboxesRouteSearch';
import { TemplateDetailPage } from './pages/TemplateDetailPage';

export type SandboxDetailSearchParams = {
  tab?: 'overview' | 'checklist' | 'diagnostics';
};

export const validateSandboxDetailSearch = (
  search: Record<string, unknown>
): SandboxDetailSearchParams => {
  const tab = search.tab;
  if (tab === 'checklist' || tab === 'diagnostics') {
    return { tab };
  }
  return { tab: 'overview' };
};

export function createSandboxRoutes<TRootRoute extends AnyRoute>(rootRoute: TRootRoute) {
  const sandboxListRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/sandboxes',
    component: SandboxListPage,
    validateSearch: validateSandboxesListSearch,
  });

  const sandboxDetailRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/sandboxes/$sandboxId',
    component: SandboxDetailPage,
    validateSearch: validateSandboxDetailSearch,
  });

  const sandboxV2DetailRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/sandboxes/v2/$sandboxId',
    component: SandboxV2DetailPage,
  });

  const templateDetailRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/sandboxes/templates/$templateId',
    component: TemplateDetailPage,
  });

  return {
    sandboxDetailRoute,
    sandboxListRoute,
    sandboxV2DetailRoute,
    templateDetailRoute,
  };
}
